const userNotificationEndPoint = {
  getUnreadCount: {
    url: "/notification/unread-count",
    method: "GET",
  },
  getNotificationList: {
    url: "/notification",
    method: "GET",
  },
};

export default userNotificationEndPoint;
